// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_OGc","cls2":"PremiumBadge-cls2_7qO PremiumBadge-cls1_OGc"};